import { render, staticRenderFns } from "./AgencyGoalSelectionBoxes.vue?vue&type=template&id=14939a8a&scoped=true"
import script from "./AgencyGoalSelectionBoxes.vue?vue&type=script&lang=ts"
export * from "./AgencyGoalSelectionBoxes.vue?vue&type=script&lang=ts"
import style0 from "./AgencyGoalSelectionBoxes.vue?vue&type=style&index=0&id=14939a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14939a8a",
  null
  
)

export default component.exports